<template>
    <dead-end-layout>
        <h1>404</h1>
        <p class="display-2 extra-light">Sorry this page does not exist.</p>
        <div class="grid-x align-center">
            <div class="cell shrink">
                <button class="button white rounded box-shadow food-pages-button" @click="$router.push({name: 'food'})"><span v-html="Icon.SANDWICH" class="color-primary"></span>Check our food</button>
            </div>
        </div>
    </dead-end-layout>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Icon } from '@/front/icons';
import DeadEndLayout from '@/components/front/ui/DeadEndLayout.vue';
@Component({components: {DeadEndLayout}})
export default class PageNotFound extends Vue
{
    get Icon() {
        return Icon;
    }
}
</script>
<style lang="scss">

.page-not-found-container {
    height: calc(100vh - 115px);
}

</style>
